module.exports = __webpack_public_path__ + "static/media/caresee-logo-white.3d63f5c0.svg";